import AsyncStorage from "@react-native-async-storage/async-storage";

/**
 * Saves the clock state to AsyncStorage.
 */
export const saveClockState = async (state: any) => {
  try {
    await AsyncStorage.setItem("clockState", JSON.stringify(state));
  } catch (error) {
    console.error("Error saving clock state:", error);
  }
};

/**
 * Loads the clock state from AsyncStorage.
 */
export const loadClockState = async () => {
  try {
    const state = await AsyncStorage.getItem("clockState");
    return state ? JSON.parse(state) : null;
  } catch (error) {
    console.error("Error loading clock state:", error);
    return null;
  }
};

/**
 * Clears the clock state from AsyncStorage.
 */
export const clearClockState = async () => {
  try {
    await AsyncStorage.removeItem("clockState");
  } catch (error) {
    console.error("Error clearing clock state:", error);
  }
};